<template>
  <ModalComponent
    ref="modal"
    iconLeftBg="#00f2"
    :onPrimaryClick="
      () => {
        onFormSubmited()
      }
    "
    :onOverlayClick="
      () => {
        onDismissClick()
      }
    "
    :onCancelClick="
      () => {
        onDismissClick()
      }
    "
    :onBackButtonClick="
      () => {
        onDismissClick()
      }
    "
    :primaryButtonLoading="false"
    :isModal="isModal"
    :isBottomSheet="isBottomSheet"
  >
    <template #titleText>
      <div
        class="max-w-full w-[450px] title-color sticky top-0"
        :class="{ 'px-8': isBottomSheet }"
        :key="'title' + promptId"
      >
        <div v-html="title"></div>
      </div>
    </template>
    <template #subtitleText>
      <div
        class="max-w-full w-[450px]"
        :class="{ 'px-8': isBottomSheet }"
        :key="'subtitle' + promptId"
      >
        <div v-html="subTitle"></div>
      </div>
    </template>

    <div
      class="max-w-full max-h-[60svh] overflow-auto w-[450px] gap-x-2"
      :key="'content' + promptId"
      :class="{ 'px-8': isBottomSheet }"
    >
      <div v-for="(option, i) in internalOptions" :key="i">
        <div class="ripple p-2 py-3" @click="selectedOption = option">
          <div class="flex items-center">
            <div class="pr-4 [&_*]:!duration-500">
              <div class="w-[22px] h-[22px] relative">
                <div
                  class="rounded-full border-2 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                  :class="{
                    'border-[#0774B9] w-[12px] h-[12px] bg-[#0774B9]':
                      selectedOption.id == option.id,
                    'border-[gray] w-[22px] h-[22px] bg-[transparent]':
                      selectedOption.id !== option.id,
                  }"
                ></div>
                <div
                  class="rounded-full border-2 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                  :class="{
                    'border-[#0774B9] w-[22px] h-[22px] bg-[transparent]':
                      selectedOption.id == option.id,
                    'border-[transparent] w-[22px] h-[22px] bg-[transparent]':
                      selectedOption.id !== option.id,
                  }"
                ></div>
              </div>
            </div>
            <div v-html="formatDisplay(option.value)"></div>
          </div>
        </div>
      </div>
    </div>

    <template #primaryButton v-if="successText">
      {{ successText }}
    </template>
    <template #cancelButton v-if="cancelText">
      {{ cancelText }}
    </template>
  </ModalComponent>
</template>

<script>
import { defineComponent } from 'vue'
import ModalComponent from './BottomSheetModal.vue'
import FormComponent from './FormComponent.vue'

export default defineComponent({
  name: 'ChoiceModal',
  components: {
    ModalComponent,
    FormComponent,
  },
  props: {
    init: {
      type: Function,
      default: () => {
        console.log('event for init not set')
      },
    },
  },
  data() {
    return {
      title: 'Title',
      subTitle: '???',
      formClasses: 'Title',
      options: [],
      successText: 'Ok',
      cancelText: 'Retour',
      canDismiss: true,
      isBottomSheet: false,
      isModal: false,
      selectedOption: {},
      eventsIds: [],
      promptId: '',
      formatDisplay(data) {
        return data
      },
    }
  },
  mounted() {
    this.initPromptFunction()
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    initPromptFunction() {
      try {
        window.choicePrompt = this.prompt
      } catch (error) {
        console.log(error)
      }
      const id = this.$Events.handleEvent(
        'request:choicePrompt',
        async ({ responseId, ...data }) => {
          const response = await this.prompt(data)
          this.$Events.dispatchEvent(responseId, response)
        },
      )
      this.eventsIds.push(id)
    },
    async prompt(data) {
      if (this.modalPromptIsVisible()) {
        console.log('end prompt when new request prompt')
        this.endPrompt(false)
        await new Promise(r => setTimeout(r, 500))
      }
      console.log('new prompt')
      this.promptId = Date.now()
      this.title = data.title || ''
      this.subTitle = data.subTitle || ''
      this.formClasses = data.formClasses || ''
      this.options = data.options || []
      this.successText = data.successText || ''
      this.cancelText = data.cancelText || ''
      this.isModal = typeof data.isModal == 'boolean' ? data.isModal : true
      this.isBottomSheet =
        typeof data.isBottomSheet == 'boolean' ? data.isBottomSheet : false
      this.formatDisplay =
        data.formatDisplay ||
        function (option) {
          return option
        }
      this.canDismiss = this.$Commons.isEmpty(data.canDismiss)
        ? true
        : !!data.canDismiss
      const promptPromise = new Promise(resolve => {
        this.handleEventEmitted(
          `choicePromptResponse:${this.promptId}`,
          resolve,
        )
      })
      this.selectedOption = {}
      if (data.defaultOption)
        this.selectedOption =
          this.internalOptions.find(option => {
            this.formatDisplay(option.value) ==
              this.formatDisplay(data.defaultOption)
          }) || {}

      await new Promise(r => setTimeout(r, 500))
      this.showModalPrompt()
      return promptPromise
    },
    handleEventEmitted(eventName, callback) {
      document.addEventListener(eventName, event => {
        callback(event.detail)
      })
    },
    dispatchEvent(eventName, data = {}) {
      document.dispatchEvent(
        new CustomEvent(eventName, {
          detail: data,
        }),
      )
    },
    showModalPrompt() {
      this.$refs.modal.show()
    },
    hideModalPrompt() {
      this.$refs.modal.hide(true)
    },
    modalPromptIsVisible() {
      return this.$refs.modal.isVisible()
    },
    onFormSubmited() {
      if (!this.selectedOption) {
        this.$Events.dispatchEvent('toast_notification', {
          type: 'warning',
          title: 'Incomplet',
          body: 'Veuillez sélectionner un élément',
        })
        return
      }
      this.endPrompt(true, this.selectedOption.value || null)
    },
    onDismissClick() {
      if (this.canDismiss) this.endPrompt()
      else {
        this.showModalPrompt()
        console.log('cannot dismiss modal')
      }
    },
    endPrompt(promptAccepted, data = null) {
      this.dispatchEvent(`choicePromptResponse:${this.promptId}`, {
        success: true,
        accepted: promptAccepted,
        data,
      })
      this.hideModalPrompt()
      this.promptId = ''
    },
  },
  computed: {
    internalOptions() {
      return (this.options || []).map((option, index) => {
        return {
          id: index,
          value: option,
        }
      })
    },
  },
})
</script>
